import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs/Subject";

@Injectable()
export class RequestHistoryService {
  studentSubscription: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  getRequest(data: any) {
    return this.http.get(`/api/Request/getRequestByPersonId`, {
      params: {
        PERSON_ID: data
      },
      responseType: "json",
      observe: "response"
    });
  }

  getRequestStatusCodeById(requestStatusCodeId: string) {
    return this.http.get(`/api/RequestStatusCode/getRequestStatusCodeById`, {
      params: { type: requestStatusCodeId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestNameById(testId: string) {
    return this.http.get(`/api/Test/getTestNameById`, {
      params: { type: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getPersonById(text: string) {
    return this.http.get(`/api/person/Person`, {
      params: { type: text },
      responseType: "json"
    });
  }

  getPersonTestById(personId: string) {
    return this.http.get(`/api/PersonTest/getPersonTestById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getTest() {
    return this.http.get(`/api/Test/getTest`);
  }

  getDates(testId: string) {
    return this.http.get(`/api/Test/getDates`, {
      params: { id: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestDateNameById(testId: string) {
    return this.http.get(`/api/TestDate/getTestDateNameById`, {
      params: { type: testId },
      responseType: "json",
      observe: "response"
    });
  }
  getPersonTestByTestId(personId: string, testDateId: string) {
    return this.http.get(`/api/PersonTest/getPersonTestByTestId`, {
      params: {
        PERSON_ID: personId,
        TEST_DATE_ID: testDateId
      },
      responseType: "json"
    });
  }

  getPersonAddressById(personId: string) {
    return this.http.get(`/api/PersonAddress/getPersonAddressById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  updatePersonActID(data: any) {
    return this.http.put(`/api/Person/updatePersonActID`, data, {
      observe: "response"
    });
  }

  updatePersonStudentStateId(data: any) {
    return this.http.put(`/api/Person/updatePersonStudentStateID`, data, {
      observe: "response"
    });
  }

  postPersonTest(data: any) {
    return this.http.post(`/api/PersonTest/createPersonTest`, data, {
      observe: "response"
    });
  }

  getReviewDetails(requestId: string) {
    return this.http.get(`/api/reviewDetail/getReviewDetailByReqId`, {
      params: { type: requestId },
      responseType: "json",
      observe: "response"
    });
  }

  postTestType(data: any) {
    return this.http.post(`/api/TestType/postTestType`, data, {
      observe: "response"
    });
  }

  postAccomsType(data: any) {
    return this.http.post(`/api/AccommsType/postAccomsType`, data, {
      observe: "response"
    });
  }

  deleteRequestDetails(data: any) {
    return this.http.delete(`/api/Delete/deleteRecord`, {
      params: { REQUEST_ID: data.REQUEST_ID, PERSON_ID: data.PERSON_ID },
      responseType: "json",
      observe: "response"
    });
  }

  deletePersonDetails(data: any) {
    return this.http.delete(`/api/Delete/deletePersonDetails`, {
      params: { PERSON_ID: data.PERSON_ID },
      responseType: "json",
      observe: "response"
    });
  }

  deleteDocumets(data: any) {
    return this.http.delete(`/api/AwsS3/deleteAllDocument`, {
      params: { PERSON_ID: data.PERSON_ID, REQUEST_ID: data.REQUEST_ID },
      responseType: "json",
      observe: "response"
    });
  }

  setValuesIsSession(PERSON_ID: string, REQUEST_ID: string) {
    return this.http.get(`/api/Request/getRequest`, {
      params: {
        PERSON_ID: PERSON_ID,
        REQUEST_ID: REQUEST_ID
      },
      responseType: "json",
      observe: "response"
    });
  }

  postRabbitMq(data: any) {
    return this.http.post(`/api/Rabbitmq/postRabbitMq`, data, {
      observe: "response"
    });
  }

  getSourceFlag() {
    return this.http.get(`/api/Rabbitmq/getSourceFlag`, {
      responseType: "json",
      observe: "response"
    });
  }

  downloadFile(data: any) {
    return window.open(
      `/api/AwsS3/downloadDecisionDocument?file=${data.fileName}&PERSON_ID=${data.PERSON_ID}&REQUEST_ID=${data.REQUEST_ID}&REVIEW_DETAIL_ID=${data.REVIEW_DETAIL_ID}`
    );
  }

  getPersonDocument(data: any) {
    return this.http.get(`/api/PersonDocument/personDocument`, {
      params: {
        type: data
      },
      responseType: "json",
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/views/services/requesthistory.service.ts